import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';

  export default class GeneralParamsItemsType extends Component{ 

    constructor(props){
      super(props);

      this.state={
          itemtypes:[],
          modalTitle:"",
          itemtypename:"",
          itemtypeid:0,

          ItemTypeIdFilter:"",
          ItemTypeNameFilter:"",
          itemtypesWithoutFilter:[],
          itemtypeNames: [],
          itemtypeExists: false,
          uniqueItemTypeIdsProducts:[], 
      }
  }

  FilterFn(){
    var ItemTypeIdFilter=this.state.ItemTypeIdFilter;
    var ItemTypeNameFilter = this.state.ItemTypeNameFilter;

    var filteredData=this.state.itemtypesWithoutFilter.filter(
        function(el){
            return el.itemtypeid.toString().toLowerCase().includes(
                ItemTypeIdFilter.toString().trim().toLowerCase()
            )&&
            el.itemtypename.toString().toLowerCase().includes(
                ItemTypeNameFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({itemtypes:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.itemtypesWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({itemtypes:sortedData});

}

changeItemTypeIdFilter = (e)=>{
  this.state.ItemTypeIdFilter=e.target.value;
  this.FilterFn();
}
changeItemTypeNameFilter = (e)=>{
  this.state.ItemTypeNameFilter=e.target.value;
  this.FilterFn();
}

refreshList(){
  axiosService.get('/itemtypes/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({itemtypes:data,itemtypesWithoutFilter:data});
  });
}


fetchItemTypeNames() {
  axiosService.get('/itemtypes/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const itemtypeNames = data.map(item => item.itemtypename);
      this.setState({ itemtypeNames: itemtypeNames });
    })
    .catch(error => {
      console.error("Error fetching itemtype names:", error);
    });
}

checkItemTypeExists = (event) => {
  const enteredItemType = event.target.value.toLowerCase(); // Convert to lowercase
  const { itemtypeNames } = this.state;
  const itemtypeExists = itemtypeNames.some((itemtype) => itemtype.toLowerCase() === enteredItemType);
  this.setState({ itemtypeExists });
};

fetchItemTypesIdsProducts() {
  axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
    .then((response) => {
      const data = response.data?.results ?? response.data;
      const uniqueItemTypeIdsProducts = [...new Set(data.map((item) => item.itemtypeid))];
      this.setState({ uniqueItemTypeIdsProducts: uniqueItemTypeIdsProducts });
    })
    .catch((error) => {
      console.error('Error fetching Products data:', error);
    });
}



componentDidMount(){
  this.refreshList();
  this.fetchItemTypeNames();
  this.fetchItemTypesIdsProducts();
}

changeItemTypeName =(e)=>{
  this.setState({itemtypename:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add ItemType",
      itemtypeid:0,
      itemtypename: "",
      itemtypeExists: false,
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit ItemType",
      itemtypeid:dep.itemtypeid,
      itemtypename:dep.itemtypename,
      initialItemtypename:dep.itemtypename,
      itemtypeExists: false,
  });
}

createClick() {
  const { itemtypename, itemtypeNames } = this.state;

  if (!itemtypename) {
    alert('Item Type Name is required');
    return;
  }

  if (itemtypeNames.some(name => name.toLowerCase() === itemtypename.toLowerCase())) {
    alert('ItemType already exists. Please provide a unique ItemType Name.');
    return;
  }


  axiosService.post('/itemtypes/', {
    itemtypename: itemtypename
  })
    .then(result => {
      alert('ItemType created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { itemtypename, initialItemtypename, itemtypeNames } = this.state;
   // Check if any changes are detected
   if (
    itemtypename === initialItemtypename
  ) {
    alert('No changes detected');
    return;
  }

  if (
    itemtypeNames.some(
      (existingItemType) =>
        existingItemType.toLowerCase() === itemtypename.toLowerCase()
    )
  ) {
    alert('ItemType already exists. Please provide a unique ItemType Name.');
    return;
  }

  if (!itemtypename) {
    alert('Item Type Name is required');
    return;
  }



  axiosService.patch('/itemtypes/'+id+'/',{
      itemtypeid:this.state.itemtypeid,
      itemtypename:this.state.itemtypename
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
  if (this.state.uniqueItemTypeIdsProducts.includes(id)) {
    alert('Cannot delete this ItemType as it is in the Products Table !');
    return; // Exit the function without making the delete request
  }
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/itemtypes/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      itemtypes,
      modalTitle,
      itemtypeid,
      itemtypename,
      itemtypeExists
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add ItemType
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeIdFilter}
      placeholder="Filter"/>

      </div>
      ItemTypeId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemTypeNameFilter}
      placeholder="Filter"/>

      </div>
      ItemType

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {itemtypes.map(dep=>
      <tr key={dep.itemtypeid} className="row-hover">
          <td className="table-text">{dep.itemtypeid}</td>
          <td className="table-text">{dep.itemtypename}</td>
          <td className="table-text">
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.itemtypeid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ItemType</span>
          <input
            type="text"
            className={`form-control ${itemtypeExists ? "is-invalid" : ""}`}
            value={itemtypename}
            onChange={this.changeItemTypeName}
            onBlur={this.checkItemTypeExists} 
            style={{ fontSize: "12px" }} 
          />
          {itemtypeExists && <div className="invalid-feedback" style={{ fontSize: "12px" }} >ItemType already exists.</div>}
        </div>

        {itemtypeid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {itemtypeid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }}  onClick={() => this.updateClick(itemtypeid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }

